const products = [
    {
        id: 1,
        name: "Sea Blue Necklace Set",
        price: 200,
        description: "Elegant Sea Blue Necklace Set crafted by skilled artisans.",
        image: process.env.PUBLIC_URL + "/images/Jewellery/Sea Blue Necklace Set.jpg"
    },
    {
        id: 2,
        name: "AssortedBrownieBox of 6",
        price: 250,
        description: "Assorted Brownie Box of 6 with premium ingredients.",
        image: process.env.PUBLIC_URL + "/images/Baked Goods/AssortedBrownieBox of 6.jpg"

    },
    {
        id: 3,
        name: "Wall-E Canvas Painting",
        price: 350,
        description: "Minimalist line art painting suitable for modern interiors.",
        image: process.env.PUBLIC_URL + "/images/Paintings/Wall-E.png"

    },
    {
        id: 4,
        name: "Dark Chocolate Mousse Pastry",
        price: 150,
        description: "Rich and creamy handmade Chocolate Mousse Pastry.",
        image: process.env.PUBLIC_URL + "/images/Baked Goods/DarkChocolateMoussePastry-Square.webp"

    },

    {
        id: 5,
        name: "Abstract Frameless Wall Painting",
        price: 500,
        description: "Modern abstract frameless wall painting for home décor.",
        image: process.env.PUBLIC_URL + "/images/products/Abstract_frameless_wall_painting.webp"
    },
    {
        id: 6,
        name: "Minimalistic Canvas Painting",
        price: 350,
        description: "Hand-painted Minimalistic canvas artwork by local artists.",
        image: process.env.PUBLIC_URL + "/images/Paintings/Minimalistic.png"
    },
    {
        id: 7,
        name: "Nature Painting",
        price: 270,
        description: "Beautiful hand-painted nature artwork inspired by nature.",
        image: process.env.PUBLIC_URL + "/images/Paintings/Nature.png"
    },
    {
        id: 8,
        name: "Pink-Green Flower Bracelet",
        price: 150,
        description: "Handcrafted Flower Bracelet with chic design.",
        image: process.env.PUBLIC_URL + "/images/Jewellery/Pink-Green Flower bracelet.jpg"
    },

    {
        id: 9,
        name: "Red Velvet White Chocolate Chip Cookies",
        price: 250,
        description: "Freshly baked red velvet cookies with white chocolate chips.",
        image: process.env.PUBLIC_URL + "/images/products/Red_Velvet_White_Chocolate_Chip_Cookies.webp"
    },
    {
        id: 10,
        name: "MultiColor Flower Earrings",
        price: 120,
        description: "Delicate handmade MultiColor Flower Earrings for everyday elegance.",
        image: process.env.PUBLIC_URL + "/images/Jewellery/MultiColor Flower Earrings.jpg"
    },
    {
        id: 11,
        name: "Cookie Brownie",
        price: 270,
        description: "Crispy homemade cookie brownie baked fresh in small batches.",
        image: process.env.PUBLIC_URL + "/images/Baked Goods/CookieBrownie_1.jpg"
    },
    {
        id: 12,
        name: "Jhumke- White Pearl",
        price: 250,
        description: "Traditional White Pearl Jhumke perfect for festive wear.",
        image: process.env.PUBLIC_URL + "/images/Jewellery/Long Jhumke- White Pearl.jpg"
    }
];

export default products;
